import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { ContentModule } from '@tytapp/content/content.module';
import { EditorCommonModule } from '@tytapp/editor-common';
import { MatSelectModule } from '@angular/material/select';
import { ConditionEditorComponent } from './condition-editor/condition-editor.component';
import { SimpleConditionEditorComponent } from './simple-condition-editor/simple-condition-editor.component';
import { ConditionValueEditorComponent } from './condition-value-editor/condition-value-editor.component';
import { ConditionSimulatorComponent } from './condition-simulator/condition-simulator.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';

const DECLARATIONS = [
    ConditionEditorComponent,
    SimpleConditionEditorComponent,
    ConditionValueEditorComponent,
    ConditionSimulatorComponent
];

const IMPORTS = [
    CommonModule,
    FormsModule,
    TYTCommonModule,
    CommonUiModule,
    ContentModule,
    EditorCommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatExpansionModule,
    MatTooltipModule
];

/**
 * This module is intended to be used in standalone deferred editor block components to group up
 * dependencies common to the editing system.
 */
@NgModule({
    imports: IMPORTS,
    exports: [ ...IMPORTS, ...DECLARATIONS ],
    declarations: DECLARATIONS
})
export class ContentEditorModule {
}